function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback, useRef } from 'react';
import style from "./index.module.scss";
import classNames from 'classnames';
import { Modal, Button } from '@tencent/tea-component';
import TpmComponentWrap from "../TpmComponentWrap/index";
import { render } from 'react-dom';
/**
 * 升级提示弹窗
 */
const UpdateModal = props => {
  const {
    className,
    size = 416,
    onBtnClick,
    children,
    onClose,
    visible,
    title = '标题2',
    content = '内容'
  } = props;
  const mainRef = useRef(null);

  // 按钮点击
  const handleClick = useCallback(e => {
    if (onBtnClick) {
      onBtnClick(e);
      return;
    }
  }, [onBtnClick]);
  const handleClose = useCallback(e => {
    onClose?.(e);
  }, [onClose]);
  return /*#__PURE__*/React.createElement(TpmComponentWrap, null, /*#__PURE__*/React.createElement("div", {
    ref: mainRef,
    className: classNames(className, style['modal-main'])
  }, /*#__PURE__*/React.createElement(Modal, {
    popupContainer: () => {
      if (mainRef.current) return mainRef.current;
      if (typeof document === 'undefined') return null;
      const dom = document.getElementById('el-update-modal');
      return dom;
    },
    visible: visible,
    caption: /*#__PURE__*/React.createElement("div", {
      className: style['modal-title']
    }, /*#__PURE__*/React.createElement("div", {
      className: style['info-img']
    }), /*#__PURE__*/React.createElement("div", null, title)),
    size: size,
    maskClosable: true,
    onClose: handleClose
  }, children ? children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, null, content), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    type: "weak",
    onClick: handleClose
  }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: handleClick
  }, "\u53BB\u5347\u7EA7"))))));
};
let el = null;
// 脱离文档流后会挂载不到指定节点，先渲染一个再api调用
if (typeof document !== 'undefined') {
  el = document.getElementById('el-update-modal');
  if (!el) {
    el = document.createElement('div');
    el.id = 'el-update-modal';
    el.className = `ma-t-theme ${style['modal-main']}`;
    document.body.appendChild(el);
  }
}

/**
 * api调用弹窗
 * @param options 弹窗配置
 * @returns 关闭弹窗的函数
 */
UpdateModal.show = options => {
  // 闭包保存当前的 title/content
  const close = (props => () => {
    UpdateModal.show({
      ...props,
      visible: false
    });
  })(options);
  const onClose = e => {
    Promise.resolve(options?.onClose?.(e)).then(close);
  };
  render( /*#__PURE__*/React.createElement(UpdateModal, _extends({
    visible: true
  }, options, {
    onClose: onClose
  })), el);
  return close;
};
if (typeof document !== 'undefined') {
  UpdateModal.show({
    visible: false
  });
}
UpdateModal.displayName = 'cc-update-modal';
export default UpdateModal;